module.exports = __webpack_public_path__ + "static/media/rock-3-D1.png";